module.exports = __webpack_public_path__ + "img/undraw_design_inspiration_fmjm.3cbcb9d0.svg";